import React from 'react';
import { Link } from 'react-router-dom';
import { editorialDuo } from '../../data/navigation';
export function EditorialSplit() {
  return <section className="mx-auto max-w-7xl px-5 pb-20 lg:px-8 lg:pb-28" data-id="element-75" data-mp="2hmec47tm5ujq">
      <ul className="grid gap-10 md:grid-cols-2 md:gap-6" data-id="element-76" data-mp="23urdi1c789xs">
        {editorialDuo.map(item => <li key={item.to} data-id="element-77" data-mp="28tujpp3x0m7c">
            <Link to={item.to} className="group block" data-id="element-78" data-mp="28t1a8gdknili">
              <div className="overflow-hidden bg-surface" data-id="element-79" data-mp="2wi43ymlhd1wd">
                <img src={item.image} alt={item.alt} className="aspect-[4/5] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-80" data-mp="2wgj8murcdexg" />
              </div>
              <h3 className="mt-5 font-display text-3xl uppercase tracking-display text-ink sm:text-4xl" data-id="element-81" data-mp="2rhzjklhgbn0v">{item.title}</h3>
              <p className="mt-1 max-w-sm font-light text-muted" data-id="element-82" data-mp="1b3pvztl1a2b3">{item.text}</p>
              <span className="mt-4 inline-block border-b-2 border-ink pb-0.5 text-xs font-semibold uppercase tracking-[0.14em] transition-colors duration-150 group-hover:border-pink group-hover:text-pink" data-id="element-83" data-mp="1g4x2zqfcqxgp">
                Shop {item.title.toLowerCase()}
              </span>
            </Link>
          </li>)}
      </ul>
    </section>;
}